import { graphql } from '@client/graphql/types';
import { useQuery } from '@apollo/client';

export const QUERY = graphql(`
  query GetHappyHour($id: ID!) {
    getHappyHour(id: $id) {
      id
      deliveryType
      discountType
      discountAmount
      minimumOrderAmount
      isActive

      timeRule {
        __typename
        ... on MenuSectionAlwaysTimeRule {
          type
        }

        __typename
        ... on MenuSectionRangeTimeRule {
          type
          start
          end
          daysOfWeek
          isAllDays
        }
      }
    }
  }
`);

export default function useGetHappyHour(id: string) {
  return useQuery(QUERY, { variables: { id } });
}
